import { createAsyncThunk } from '@reduxjs/toolkit'

import * as api from 'connections/restApi'

export const get = createAsyncThunk('cyclereasons/get', async () => {
  const response = await api.getCyclereasons()
  return response
})
